import React from "react";
import { Box, Button, Typography, Slide, Grid } from "@mui/material";
import {
  bot1,
  bot2,
  chanel,
  chat,
  operator,

} from "../../srevices/contacts";
import { useContactsStyles } from "./Contacts.styles"; // Импорт стилей

const Contacts = () => {
  const classes = useContactsStyles();

  return (
    <Box sx={classes.container}>
      <Box sx={classes.background} />

      <Slide direction="left" in={true} timeout={1000}>
        <Typography variant="h4" sx={classes.title}>
          Контакты
        </Typography>
      </Slide>

      <Grid container spacing={2} sx={classes.gridContainer}>
        <Grid item sx={classes.gridItem}>
          <Slide direction="left" in={true} timeout={1000}>
            <Button
              sx={classes.button}
              component="a"
              href={chat}
              target="_blank"
              rel="noopener noreferrer"
            >
              Чат в Telegram
            </Button>
          </Slide>
        </Grid>

        <Grid item sx={classes.gridItem}>
          <Slide direction="left" in={true} timeout={1000}>
            <Button
              sx={classes.button}
              component="a"
              href={chanel}
              target="_blank"
              rel="noopener noreferrer"
            >
              Канал с отзывами
            </Button>
          </Slide>
        </Grid>

        <Grid item sx={classes.gridItem}>
          <Slide direction="left" in={true} timeout={1000}>
            <Button
              sx={classes.button}
              component="a"
              href={operator}
              target="_blank"
              rel="noopener noreferrer"
            >
              Оператор 
            </Button>
          </Slide>
        </Grid>

        <Grid item sx={classes.gridItem}>
          <Slide direction="left" in={true} timeout={1000}>
            <Button
              sx={classes.button}
              component="a"
              href={bot1}
              target="_blank"
              rel="noopener noreferrer"
            >
              Бот 
            </Button>
          </Slide>
        </Grid>

        <Grid item sx={classes.gridItem}>
          <Slide direction="left" in={true} timeout={1000}>
            <Button
              sx={classes.button}
              component="a"
              href={bot2}
              target="_blank"
              rel="noopener noreferrer"
            >
              Бот Распределитель
            </Button>
          </Slide>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Contacts;
